<script lang="ts">
  import Icon from './Icon.svelte';
  import type { TripCityView } from '~/shared/api.js';

  let {
    selectedCityId,
    cities,
    editable = true,
    onPick,
  }: {
    selectedCityId: number | null;
    cities: TripCityView[];
    editable?: boolean;
    onPick: (cityId: number | null) => void;
  } = $props();

  const selectedCity = $derived(
    selectedCityId === null ? null : cities.find((c) => c.id === selectedCityId) ?? null,
  );
  let open: boolean = $state(false);

  function pick(id: number | null) {
    open = false;
    if (id !== selectedCityId) onPick(id);
  }
</script>

<div class="city-row">
  {#if editable}
    <button
      type="button"
      class="city-chip"
      aria-haspopup="menu"
      aria-expanded={open}
      onclick={() => (open = !open)}
    >
      <Icon name="map-pin" size={12} strokeWidth={2.25} />
      <span>{selectedCity?.name ?? 'Unassigned'}</span>
      <Icon name="pencil" size={11} strokeWidth={2.25} />
    </button>
    {#if open}
      <div class="city-picker" role="menu">
        {#each cities as c (c.id)}
          <button
            type="button"
            class="city-option"
            class:active={selectedCityId === c.id}
            role="menuitem"
            onclick={() => pick(c.id)}
          >{c.name}</button>
        {/each}
        <button
          type="button"
          class="city-option"
          class:active={selectedCityId === null}
          role="menuitem"
          onclick={() => pick(null)}
        >Unassigned</button>
      </div>
    {/if}
  {:else}
    <span class="city-chip city-chip--readonly">
      <Icon name="map-pin" size={12} strokeWidth={2.25} />
      <span>{selectedCity?.name ?? 'Unassigned'}</span>
    </span>
  {/if}
</div>

<style>
  .city-row {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  .city-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    background: var(--color-surface-soft);
    color: var(--color-ink);
    border: 0;
    border-radius: 9999px;
    padding: 0.25rem 0.625rem;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
  }
  .city-chip:hover:not(.city-chip--readonly) { background: var(--color-surface-strong); }
  .city-chip--readonly { cursor: default; }
  .city-picker {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    background: var(--color-canvas);
    border: 1px solid var(--color-hairline);
    border-radius: var(--radius-md);
    box-shadow:
      rgba(0, 0, 0, 0.04) 0 0 0 1px,
      rgba(0, 0, 0, 0.08) 0 4px 12px;
    min-width: 180px;
    overflow: hidden;
    z-index: 10;
  }
  .city-option {
    display: block;
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    padding: 0.5rem 0.875rem;
    font-size: 13px;
    color: var(--color-ink);
    cursor: pointer;
    font-family: inherit;
  }
  .city-option:hover { background: var(--color-surface-soft); }
  .city-option.active { background: var(--color-surface-soft); font-weight: 600; }
</style>
